<div>
    <h1 mat-dialog-title>Begin Enrollment?</h1>
    <div class="modal-style"
         mat-dialog-content
         *ngIf="data.parentComponent.loc.length > 1">
        <mat-icon class="icon-color">warning</mat-icon>
        <div>
            <span class="line-break">
                Missing Plan Selections for &nbsp;{{ data.parentComponent.loc.join(', ') }}
            </span>
            <br />
            <span class="line-break">
                If you do not intend to enroll in these lines of coverage, click
                <b>Continue</b> to begin enrollment. Otherwise, click <b>Cancel</b> to select
                plans.
            </span>
        </div>
    </div>
    <div class="modal-style"
         mat-dialog-content
         *ngIf="data.parentComponent.loc.length === 1">
        <mat-icon class="icon-color">warning</mat-icon>
        <div>
            <span class="line-break">Missing Plan Selections for &nbsp;{{ data.parentComponent.loc }}</span>
            <br />
            <span class="line-break">
                If you do not intend to enroll in &nbsp;{{ data.parentComponent.loc }},
                click <b>Continue</b> to begin enrollment. Otherwise, click <b>Cancel</b> to
                select &nbsp;{{ data.parentComponent.loc }} plans.
            </span>
        </div>
    </div>
</div>

<ng-container *ngIf="isLoading === true">
    <div class="spinner">
        <mat-spinner [diameter]="40"></mat-spinner>
    </div>
</ng-container>
<div mat-dialog-actions *ngIf="!isLoading">

    <button mat-raised-button class="font-color" (click)="onCancelClick()" cdkFocusInitial>
        CANCEL
    </button>
    <button mat-raised-button color="warn" (click)="callAPI()" cdkFocusInitial>
        CONTINUE
    </button>
    <!-- input tag is only meant to remove the Focus from the buttons -->
    <input cdkFocusInitial type="text" style="display: none" />
</div>
